// @description: for new blog post body

import { mimeTypes } from 'client/constants/editorSettings'
import { useAppDispatch } from 'client/hooks/use-dispatch'
import { getSeo } from 'client/reducers/pageReducer'
import { useBlogPost, usePage } from 'client/store'
import { getBlogPostImage } from 'client/store/blogPost/blogPostReducer'
import { updateSeoProperty } from 'client/store/page/pageActions'
import { getFirstEntityByType } from 'client/store/page/pageSelectors'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostBodyInterface } from 'common/types/entities/blog-post-body-interface'
import React from 'react'
import { FileUpload } from '../components'
import BlogPostSettingsOld from './BlogPostSettings'
import { Background } from './components/background'
import Seo from './components/Seo'
import Tracking from './components/Tracking'

export const BlogPostSettingsResolver = () => {
  const isMigratedBodyEntity = usePage(page =>
    getFirstEntityByType(page, EntityTypeEnum.BlogPostBody),
  )

  if (isMigratedBodyEntity) {
    return <BlogPostSettings />
  }
  return <BlogPostSettingsOld />
}

export const BlogPostSettings = () => {
  const dispatch = useAppDispatch()
  const seo = usePage(getSeo)
  const blogPostImage = useBlogPost(getBlogPostImage)
  return (
    <>
      <Background<BlogPostBodyInterface> />
      <Seo
        fileUpload={
          <FileUpload
            fileId={undefined} // NOTE: to fix typescript error
            mimeTypes={mimeTypes.image}
            fileName={seo.socialImage || blogPostImage?.name}
            afterUpload={file =>
              dispatch(updateSeoProperty('socialImage')(file.id))
            }
            removeFile={
              seo.socialImage
                ? () => dispatch(updateSeoProperty('socialImage')(null))
                : null
            }
            label="page_settings.seo.social_image.label"
          />
        }
      />
      <Tracking />
    </>
  )
}
